export default {
  // Page title and subtitle
  'page.mainTitle': 'Générateur de Timestamp Discord',
  'page.mainTitleSEO': 'Générateur de Timestamp Discord - Créez des Codes <t:format> Dynamiques',
  'page.subtitle': 'Générez des timestamps Discord avec conversion automatique de fuseau horaire pour tout le monde',

  // Generator tool section
  'page.generatorTitle': 'Générateur de Timestamp Discord Interactif',
  'page.selectDateTime': 'Sélectionner Date & Heure :',
  'page.chooseFormat': 'Choisir le Format d\'Affichage :',
  'page.generatedCode': 'Code Discord Généré :',
  'page.preview': 'Aperçu dans Discord :',
  'page.copyCode': 'Copier le Code',

  // Format options
  'page.format.t': 'Heure Courte',
  'page.format.t.example': '16:30',
  'page.format.t.desc': 'Affiche uniquement l\'heure, format court',

  'page.format.T': 'Heure Longue',
  'page.format.T.example': '16:30:00',
  'page.format.T.desc': 'Affiche uniquement l\'heure, avec secondes',

  'page.format.d': 'Date Courte',
  'page.format.d.example': '31/12/2024',
  'page.format.d.desc': 'Affiche uniquement la date, format court',

  'page.format.D': 'Date Longue',
  'page.format.D.example': '31 décembre 2024',
  'page.format.D.desc': 'Affiche la date complète',

  'page.format.f': 'Date/Heure Courte',
  'page.format.f.example': '31 décembre 2024 16:30',
  'page.format.f.desc': 'Format le plus couramment utilisé',

  'page.format.F': 'Date/Heure Longue',
  'page.format.F.example': 'mardi 31 décembre 2024 16:30',
  'page.format.F.desc': 'Date et heure complètes avec jour de la semaine',

  'page.format.R': 'Temps Relatif',
  'page.format.R.example': 'il y a 2 heures / dans 3 jours',
  'page.format.R.desc': 'Compte à rebours dynamique ou temps écoulé',

  // Format reference table
  'page.formatReference': 'Référence des Formats de Timestamp Discord',
  'page.formatCode': 'Code de Format',
  'page.style': 'Style',
  'page.exampleOutput': 'Exemple de Sortie',
  'page.useCase': 'Cas d\'Utilisation',

  'page.useCase.t': 'Heures de début d\'événement',
  'page.useCase.T': 'Chronométrage précis',
  'page.useCase.d': 'Affichage de date compact',
  'page.useCase.D': 'Affichage de date complet',
  'page.useCase.f': 'Usage général',
  'page.useCase.F': 'Annonces formelles',
  'page.useCase.R': 'Comptes à rebours, temps depuis événements',

  // How to use section
  'page.howToUse': 'Comment Utiliser les Timestamps Discord',
  'page.step1': 'Générez votre code de timestamp',
  'page.step1Desc': 'Utilisez l\'outil ci-dessus pour sélectionner une date/heure et un format',

  'page.step2': 'Copiez le code généré',
  'page.step2Desc': 'Exemple : <t:1735689000:F>',

  'page.step3': 'Collez dans n\'importe quel message Discord',
  'page.step3Desc': 'Fonctionne dans les canaux textuels, MPs, fils de discussion et posts de forum',

  'page.step4': 'Tout le monde le voit dans son fuseau horaire !',
  'page.step4Desc': 'Discord convertit automatiquement vers l\'heure locale de chaque utilisateur',

  // FAQ section
  'page.faq': 'FAQ Timestamp Discord',

  'page.faq.q1': 'Qu\'est-ce qu\'un timestamp Discord ?',
  'page.faq.a1': 'Les timestamps Discord utilisent le temps Unix epoch avec des codes de format spéciaux (<t:timestamp:format>) pour afficher des heures dynamiques qui s\'ajustent automatiquement au fuseau horaire local de chaque utilisateur.',

  'page.faq.q2': 'Pourquoi utiliser les timestamps Discord au lieu de taper l\'heure ?',
  'page.faq.a2': 'Les timestamps Discord se convertissent automatiquement vers le fuseau horaire local de chaque utilisateur, donc tout le monde voit l\'heure correcte pour son emplacement. Cela élimine la confusion lors de la coordination d\'événements à travers les fuseaux horaires.',

  'page.faq.q3': 'Quel format dois-je utiliser ?',
  'page.faq.a3': 'Utilisez <t:timestamp:R> pour les comptes à rebours et événements, <t:timestamp:F> pour les annonces formelles, et <t:timestamp:f> pour un usage général.',

  'page.faq.q4': 'Les timestamps Discord fonctionnent-ils dans tous les canaux ?',
  'page.faq.a4': 'Oui ! Les timestamps Discord fonctionnent dans les canaux textuels, MPs, fils de discussion, posts de forum et même dans les sujets de canal.',

  'page.faq.q5': 'Puis-je utiliser les timestamps Discord dans les embeds ?',
  'page.faq.a5': 'Oui, les timestamps Discord fonctionnent dans les descriptions d\'embed et les valeurs de champs lors de l\'utilisation de bots Discord.',

  'page.faq.q6': 'Que se passe-t-il si j\'utilise un timestamp invalide ?',
  'page.faq.a6': 'Discord affichera le code brut sans le convertir. Assurez-vous d\'utiliser des timestamps Unix valides.',

  // Related tools section
  'page.relatedTools': 'Outils de Timestamp Connexes',
  'page.needUnixTimestamp': 'Besoin d\'un Timestamp Unix ?',
  'page.needUnixTimestampDesc': 'Utilisez notre Convertisseur de Timestamp Unix pour convertir n\'importe quelle date en temps epoch.',
  'page.checkYouTubeTool': 'Ou consultez le Créateur de Timestamp YouTube',

  // Common use cases
  'page.commonUseCases': 'Cas d\'Utilisation Courants',
  'page.useCase1.title': 'Planification d\'Événements',
  'page.useCase1.desc': 'Annoncez des soirées de jeu, des watch parties de films ou des événements communautaires',

  'page.useCase2.title': 'Chronos de Raid',
  'page.useCase2.desc': 'Coordonnez les sessions de jeu à travers différents fuseaux horaires',

  'page.useCase3.title': 'Comptes à Rebours de Sortie',
  'page.useCase3.desc': 'Créez de l\'enthousiasme pour les lancements de jeux, sorties d\'albums ou mises à jour',

  'page.useCase4.title': 'Rappels de Réunion',
  'page.useCase4.desc': 'Planifiez des réunions d\'équipe dans les serveurs communautaires',

  'page.useCase5.title': 'Dates Limites de Concours',
  'page.useCase5.desc': 'Définissez des dates limites claires pour les cadeaux et compétitions',

  'page.useCase6.title': 'Événements de Serveur',
  'page.useCase6.desc': 'Suivez les anniversaires, jalons et occasions spéciales',
};
